import { render, staticRenderFns } from "./PostCreation_ImageUpload.vue?vue&type=template&id=71f745da&scoped=true&"
import script from "./PostCreation_ImageUpload.vue?vue&type=script&lang=js&"
export * from "./PostCreation_ImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./PostCreation_ImageUpload.vue?vue&type=style&index=0&id=71f745da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f745da",
  null
  
)

export default component.exports